import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #CARD
\*------------------------------------ */
/**
 * 1) A card is an organized block that typically contains a title, image,
 * text, and/or calls to action. It is made up of a required body slot and optional
 * footer slot to place other components and content within.
 */
.cat-c-card {
  display: var(--cat-card-display, flex);
  flex-flow: var(--cat-card-flex-direction, column) wrap;
  width: 100%;
  height: 100%;
  padding: var(--cat-card-padding, calc(var(--size-base-unit) * 2));
  border-width: var(--cat-border-width-sm);
  border-style: solid;
  border-color: var(--cat-card-border-color, var(--cat-theme-color-border-default));
  border-radius: var(--cat-border-radius-lg);
  background-color: var(--cat-theme-color-background-default);
}

/**
 * Card that renders as a link
 */
a.cat-c-card {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

/**
 * Card that renders with no padding
 */
.cat-c-card--remove-padding {
  padding: 0;
}

/**
* Bare card
* 1) Remove border and padding so that it's flush with the grid item
*/
.cat-c-card--bare {
  border: 0;
  padding: 0;
  border-radius: 0;
  box-shadow: none;
  background: none;
}

/**
 * Card header
 */
.cat-c-card__header {
  margin-block-end: calc(var(--size-base-unit) * 2);
}
.cat-c-card--remove-padding .cat-c-card__header {
  margin-block-end: 0;
}

.cat-c-card__header:empty {
  display: none;
}

/**
 * Card body
 * 1) Flex applied to always fill the remaining space of the card
 */
.cat-c-card__body {
  display: block;
  flex: 1 0 auto;
  max-width: 100%;
}

/**
 * Card footer
 */
.cat-c-card__footer {
  display: block;
  width: 100%;
  margin-block-start: calc(var(--size-base-unit) * 2);
}
.cat-c-card--remove-padding .cat-c-card__footer {
  margin-block-start: 0;
}

/**
 * Bare on mobile
 * 1) Remove border and padding on mobile
 */
@media all and (max-width: 48rem) {
  .cat-c-card--bare-on-mobile {
    border: none;
    padding: 0;
  }
}
`;
       